import {
    RETREIVE_PRODUCTS_MUTATION,
    SET_SHOP_LOADING_TO_FALSE,
    SET_SHOP_LOADING_TO_TRUE,
    RETREIVE_CATEGORIES_MUTATION,
    SET_FILTER_CATEGORY_MUTATION,
    SET_FILTER_TYPE_MUTATION,
    RETREIVE_FEATURES_FILTER_MUTATION,
    SET_FEATURES_FILTER_SELECTED,
    SET_TYPES_FILTER_SELECTED
} from "./types";
import { shuffle } from "@/js/utils";
import Vue from "vue";

const shopMutations = {
    [RETREIVE_PRODUCTS_MUTATION](state, items) {
        state.shopItems = shuffle([...items]);
    },
    [SET_SHOP_LOADING_TO_TRUE](state) {
        state.shopLoading = true;
    },
    [SET_SHOP_LOADING_TO_FALSE](state) {
        state.shopLoading = false;
    },
    [RETREIVE_CATEGORIES_MUTATION](state, categories) {
        state.categories = [...categories];
    },
    [SET_FILTER_CATEGORY_MUTATION](state, category) {
        state.filter.category = { ...category};
    },
    [SET_FILTER_TYPE_MUTATION](state, type) {
        state.filter.type = type;
    },
    [SET_FEATURES_FILTER_SELECTED](state, filter) {
        Vue.set(state, "featuresFilterSelected", filter);
    },
    [SET_TYPES_FILTER_SELECTED](state, filter) {
        Vue.set(state, "typesFilterSelected", filter);
    },
    [RETREIVE_FEATURES_FILTER_MUTATION](state, filter){
        Vue.set(state, "featuresFilter", filter);
    }
};

export default shopMutations;
